<template>
  <div class="scriptInfo">
    <div style="position: absolute;height: 100%;width: 100%;">
      <div :style="{backgroundImage: 'url(' + chartletUrl + ')',backgroundSize:'cover',height:'12rem',width:'100%',}">
        <div class="topImg">
          <img src="../assets/images/mitan/backImg.png" class="back_img">
          <img src="../assets/images/mitan/topShare.png" class="back_img">
        </div>
        <div class="bookInfo">
          <div class="infos">
            <div class="book_title">{{playName}}</div>
            <div class="book_class">{{fictionType}}</div>
            <div class="book_class" style="margin-top: 1rem">作者：<span v-for="item in authorList">{{item.nickName}} </span></div>
            <div class="book_class">插画：<span v-for="item in illustratorList">{{item.nickName}} </span></div>
          </div>
          <div class="bookImg">
            <img :src="coverUrl" />
          </div>
        </div>
      </div>
      <div class="content">
        <div class="content_top">
          <div class="content_top_left">
            <div  class="content_top_lefts">
              <div class="content_num">{{fictionAvgScore}}</div>
              <div v-for="(item,index) in fictionScore">
                <img :src="item">
              </div>
            </div>
            <div class="people_num">{{scoreCount}}人评分</div>
          </div>
          <div class="content_center">
            <div>
              {{fictionWords}} <div class="danwei">万</div>
            </div>
            <div class="people_num">字数</div>
          </div>
          <div class="content_right">
            <div>
              {{readCount}} <div class="danwei">万</div>
            </div>
            <div class="people_num">人气值</div>
          </div>
        </div>
        <div class="content_details" id="content_details">
          {{introduction}}
          <span @click="toogleChange" class="unfold">{{isActive?"...展开":"收起"}}</span>
        </div>
        <div class="line"></div>
        <div class="commentTitle">精彩评价</div>
        <div class="commentList">
          <div class="commentItem" v-for="item in commentList">
            <div class="itemLeft">
              <img :src="item.avatarUrl">
              <div class="commentInfo">
                <div class="infoName">{{item.nickName}}</div>
                <div class="infoContent">{{item.content}}</div>
              </div>
            </div>
            <div class="infoTime">{{item.commentTime}}</div>
          </div>
        </div>
      </div>
      <div class="bottom_btn">
        <div class="startRead" @click="join">开始阅读</div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {FormatTime, FormDate} from '../assets/js/time'
  import StarLight from "../assets/images/scriptInfos/game_star_whole_icon@2x.png";//满星
  import StarHalf from "../assets/images/scriptInfos/game_star_half_icon@2x.png";//半星
  import StarGray from "../assets/images/scriptInfos/game_star_none_icon@2x.png";//无星
  import {appUrlAndroid, appUrlIOS} from "../assets/js/base64";

  export default {
    name: "fiction",
    data(){
      return {
        isActive: true,
        playName:'',//剧本名字
        coverUrl:'',//剧本封面
        fictionType:'',//剧本类型
        chartletUrl:'',//剧本贴图类型
        fictionAvgScore:'',//剧本评分
        fictionWords:'',//剧本字数
        scoreCount:'',//剧本评分人数
        readCount:'',//剧本人气值
        introduction:'',//剧本简介
        commentList:[],//剧本评论合集
        fictionScore:null,//剧本评分星星数
        illustratorList:[],//剧本插画
        authorList:[],//剧本作者
        chartletUrl:'',//剧本贴图
      }
    },
    methods:{
      toogleChange() {
        this.isActive = !this.isActive;
        let details = document.getElementById('content_details')
        if (!this.isActive) {
          details.style.setProperty('height','auto');
        } else {
          details.style.setProperty('height','3rem');
        }
      },
      join(){
        this.baseUrl='https://a.app.qq.com/o/simple.jsp?pkgname=com.wzf.fan'
        var fmId = this.$route.query.fmId;
        console.log(fmId);
        if (this.isAndroid) {
          window.location.href = this.baseUrl+`&android_schema=${appUrlAndroid( "400001",`fmId=${fmId}`)}`;
        } else if (this.isiOS) {
          let ua = navigator.userAgent.toLowerCase();
          if(ua.match(/QQ/i) == "qq"){
            this.isAppopen = true
          }else{
            window.location.href = appUrlIOS('400001',`fmId=${fmId}` );
          }
        }else{
          window.location.href = 'http://share.xiyacs.com/#/open'
        }
      },
    },
    created() {
      var fmId = this.$route.query.fmId;
      axios({
        url:this.$interfaces.fiction,
        method:'POST',
        data:{
          "fmId": fmId
        },
        type:'json'
      }).then(res=>{
        console.log(res);
        let data = res.data.data
        this.playName = data.fictionInfo.fictionName;
        this.coverUrl = data.fictionInfo.coverUrl;
        this.fictionType = data.fictionInfo.fictionType;
        this.chartletUrl = data.fictionInfo.chartletUrl;
        this.fictionAvgScore = data.fictionInfo.fictionAvgScore;
        this.fictionWords = parseFloat(data.fictionInfo.fictionWords);
        this.scoreCount = data.fictionInfo.scoreCount;
        this.readCount = (parseInt(data.fictionInfo.readCount)/10000).toFixed(2);
        this.introduction = data.fictionInfo.introduction;
        this.commentList = data.commentList;
        this.chartletUrl = data.fictionInfo.chartletUrl;
        this.commentList.forEach(item => {
          item.commentTime = FormatTime(item.commentTime*1000);
        });
        this.authorList = data.authorList;
        this.illustratorList = data.illustratorList;
        let num = parseInt(data.fictionInfo.fictionAvgScore)
        let fictionScore = [];
        let intScore = Math.floor(num / 2);
        let hasHalf = num - intScore * 2 > 0;
        for (let i = 0; i < 5; i++) {
          if (i < intScore) {
            fictionScore.push(StarLight);
          } else if (i === intScore) {
            if (hasHalf) {
              fictionScore.push(StarHalf);
            } else {
              fictionScore.push(StarGray);
            }
          } else {
            fictionScore.push(StarGray);
          }
        }
        this.fictionScore = fictionScore;
      }).catch(res=>{
        console.log(res);
      })
    }
  }
</script>

<style scoped>
  *{
    text-align:left !important;
  }
  .app{
    background-color: #2aa0a4
  }
  .scriptInfo{
    width: 100%;
    height: 100%;
    position: relative;
  }
  .topImg{
    width: 95%;
    height: 1.2rem;
    /*background-color: deeppink;*/
    margin: 0rem auto;
    padding-top: 0.8rem;
    display: flex;
    justify-content: space-between;
  }
  .back_img{
    width: 1.2rem;
    height: 1.2rem;
  }
  .bookInfo{
    width: 90%;
    height:8rem;
    margin: 1.2rem auto 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .book_title{
    font-size: 0.9rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }
  .book_class{
    font-size: 0.6rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    margin-top: 0.4rem;
  }
  .bookImg{
    width: 5rem;
    height: 6.65rem;
    background: #D8D8D8;
    border-radius: 0.6rem;
  }
  .bookImg img{
    width: 100%;
    height: 100%;
    border-radius: 0.6rem;
  }
  .content{
    height: 100%;
    background-color: #FFFFFF;
    border-radius: 0.9rem 0.9rem 0 0;
    width: 100%;
    position: relative;
    top: -2rem;
  }
  .content_top{
    height: 3rem;
    background-color: #FFFFFF;
    border-radius: 0.9rem 0.9rem 0 0;
    padding: 0 5%;
    display: flex;
    justify-content: space-between;
  }
  .content_num{
    font-size: 1.1rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #353B42;
    margin-right: 0.4rem;
  }
  .content_top_left{
    height: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .content_top_left img{
    width: 0.9rem;
    height: 0.9rem;
  }
  .content_top_lefts{
    height: 1.55rem;
    display: flex;
    align-items:center;
  }
  .content_top_lefts img{
    width: 0.9rem;
    height: 0.9rem;
  }
  .content_center,.content_right{
    display: flex;
    align-items:center;
    flex-direction: column;
    justify-content: center;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #353B42;
    font-size: 1.1rem;
  }
  .content_center .danwei,.content_right .danwei{
    display: inline-block;
    font-size: 0.5rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #353B42;
  }
  .people_num{
    font-size: 0.5px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #A1A8B3;
  }
  .content_details{
    width: 90%;
    min-height:3rem;
    height: 0;
    margin: 0.5rem 5%;
    font-size: 0.7rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #57565A;
    line-height: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
  }
  .unfold{
    color: #38daf0;
    position: absolute;
    font-size: 0.75rem;
    right: 0;
    bottom: 0;
    background-color: #FFFFFF;
  }
  .line{
    width: 100%;
    height: 0.3rem;
    background: #F6F7FA;
    margin: 0 auto;
  }
  .commentTitle{
    width: 90%;
    height: 2.5rem;
    line-height: 2.5rem;
    margin: 0 auto;
    font-size: 0.8rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #353B42;
  }
  .commentList{
    width: 90%;
    margin: 0 auto;

  }
  .commentItem{
    height: 3rem;
    display: flex;
    justify-content: space-between;
    border-bottom: .025rem solid #f0f0f0;
    height: auto;
    margin-top: 0.6rem;
    padding-bottom: 0.6rem;
  }
  .commentItem img{
    height: 1.5rem;
    width: 1.5rem;
    border-radius: 50%;
    margin-right: 0.6rem;
  }
  .commentInfo{
    width: 90%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 2.5rem;
  }
  .infoName{
    font-size: 0.6rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #57565A;
  }
  .infoContent{
    font-size: 0.7rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    overflow: hidden;
    color: #57565A;
  }
  .infoTime{
    font-size: 0.6rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #C1C4CC;
  }
  .itemLeft{
    height: 2.5rem;
    width: 85%;
    display: flex;
    justify-content: space-between;
  }
  .bottom_btn{
    width: 100%;
    height: 3.45rem;
    background: #FFFFFF;
    box-shadow: 0px 0px 0.3rem 0px rgba(220, 220, 220, 0.5);
    position: fixed;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .startRead{
    width: 13.95rem;
    height: 2.7rem;
    background: linear-gradient(90deg, #30CFEE 0%, #53FFF6 100%);
    border-radius: 1.35rem;
    font-size:0.9rem;
    text-align: center !important;
    line-height: 2.7rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
  }
  .commentList .commentItem:last-child{
    margin-bottom: 3.9rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/fiction.vue